// Colour values are taken from the Tailwind scale, which the ngest-rockset-dbt webapp
// frontend already uses. Sharing one set of values means the two front ends can converge
// without a re-pick, and the scale is well tested for contrast.
//
// Every pairing below meets WCAG AA (4.5:1 for body text). Two pairings in the previous
// palette did not: white-ish text on the primary green was 3.07:1, and the secondary grey
// on the page background was 3.23:1.
//
//   white on primary #047857   5.48:1
//   primary as link on white   5.48:1   (emerald-600 would be 3.77:1, so 700 is the floor)
//   text.primary on paper     17.85:1
//   text.secondary on paper    7.58:1
//   white on error #DC2626     4.83:1
//
// Warning is the exception: white on amber is only 3.19:1, so it carries dark text.

export default {
  mode: 'light',           // v5 name; the previous `type` key was MUI v4 and was ignored
  primary: {
    main: '#047857',       // emerald-700
    light: '#10B981',      // emerald-500, for hover and subtle fills
    dark: '#065F46',       // emerald-800
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#475569',       // slate-600
    light: '#64748B',      // slate-500
    dark: '#334155',       // slate-700
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#DC2626',       // red-600
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#D97706',       // amber-600
    contrastText: '#1F2937',  // dark text: white on amber fails AA
  },
  info: {
    main: '#0369A1',       // sky-700
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#047857',       // matches primary, so "good" reads consistently
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#0F172A',    // slate-900
    secondary: '#475569',  // slate-600
    disabled: '#94A3B8',   // slate-400
  },
  background: {
    default: '#F8FAFC',    // slate-50, so white surfaces lift off the page
    paper: '#FFFFFF',
  },
  divider: '#CBD5E1',      // slate-300
  action: {
    hover: 'rgba(15, 23, 42, 0.04)',
    selected: 'rgba(4, 120, 87, 0.08)',
    disabled: '#CBD5E1',   // slate-300
    disabledBackground: '#F1F5F9', // slate-100
  },
};
